import { log, renderQuery } from '@sembo-private/utils';
import { last as last$1, keyBy, isEqual, flatten, map as map$1, intersection, sortBy, take as take$1 } from 'lodash';
import { map, combineLatest, distinctUntilChanged, Subject, lastValueFrom, take, ReplaySubject, firstValueFrom, first, Observable } from 'rxjs';
import { SuperClusterAlgorithm, MarkerClusterer } from '@googlemaps/markerclusterer';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var fails$g = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$f = fails$g;

var functionBindNative = !fails$f(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$3 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var call$g = FunctionPrototype$2.call;
var uncurryThisWithBind = NATIVE_BIND$3 && FunctionPrototype$2.bind.bind(call$g, call$g);

var functionUncurryThisRaw = function (fn) {
  return NATIVE_BIND$3 ? uncurryThisWithBind(fn) : function () {
    return call$g.apply(fn, arguments);
  };
};

var uncurryThisRaw$1 = functionUncurryThisRaw;

var toString$4 = uncurryThisRaw$1({}.toString);
var stringSlice$1 = uncurryThisRaw$1(''.slice);

var classofRaw$2 = function (it) {
  return stringSlice$1(toString$4(it), 8, -1);
};

var classofRaw$1 = classofRaw$2;
var uncurryThisRaw = functionUncurryThisRaw;

var functionUncurryThis = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw$1(fn) === 'Function') return uncurryThisRaw(fn);
};

var uncurryThis$d = functionUncurryThis;
var fails$e = fails$g;
var classof$7 = classofRaw$2;

var $Object$4 = Object;
var split = uncurryThis$d(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$e(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$7(it) == 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$4 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$3 = isNullOrUndefined$4;

var $TypeError$f = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$3 = function (it) {
  if (isNullOrUndefined$3(it)) throw $TypeError$f("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$2 = indexedObject;
var requireObjectCoercible$2 = requireObjectCoercible$3;

var toIndexedObject$5 = function (it) {
  return IndexedObject$2(requireObjectCoercible$2(it));
};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$k =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var shared$3 = {exports: {}};

var global$j = global$k;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$6 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$6(global$j, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$j[key] = value;
  } return value;
};

var global$i = global$k;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = global$i[SHARED] || defineGlobalProperty$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$3.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.25.5',
  mode: 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.25.5/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var requireObjectCoercible$1 = requireObjectCoercible$3;

var $Object$3 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$5 = function (argument) {
  return $Object$3(requireObjectCoercible$1(argument));
};

var uncurryThis$c = functionUncurryThis;
var toObject$4 = toObject$5;

var hasOwnProperty = uncurryThis$c({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$4(it), key);
};

var uncurryThis$b = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$3 = uncurryThis$b(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$3(++id + postfix, 36);
};

var documentAll$2 = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var IS_HTMLDDA = typeof documentAll$2 == 'undefined' && documentAll$2 !== undefined;

var documentAll_1 = {
  all: documentAll$2,
  IS_HTMLDDA: IS_HTMLDDA
};

var $documentAll$1 = documentAll_1;

var documentAll$1 = $documentAll$1.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$l = $documentAll$1.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll$1;
} : function (argument) {
  return typeof argument == 'function';
};

var global$h = global$k;
var isCallable$k = isCallable$l;

var aFunction = function (argument) {
  return isCallable$k(argument) ? argument : undefined;
};

var getBuiltIn$8 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$h[namespace]) : global$h[namespace] && global$h[namespace][method];
};

var getBuiltIn$7 = getBuiltIn$8;

var engineUserAgent = getBuiltIn$7('navigator', 'userAgent') || '';

var global$g = global$k;
var userAgent$3 = engineUserAgent;

var process$3 = global$g.process;
var Deno$1 = global$g.Deno;
var versions = process$3 && process$3.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$3) {
  match = userAgent$3.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$3.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */

var V8_VERSION$1 = engineV8Version;
var fails$d = fails$g;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$d(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$1 && V8_VERSION$1 < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var NATIVE_SYMBOL$2 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$2
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var global$f = global$k;
var shared$2 = shared$3.exports;
var hasOwn$b = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL$1 = symbolConstructorDetection;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var WellKnownSymbolsStore = shared$2('wks');
var Symbol$1 = global$f.Symbol;
var symbolFor = Symbol$1 && Symbol$1['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID$1 ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$h = function (name) {
  if (!hasOwn$b(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL$1 || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL$1 && hasOwn$b(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else if (USE_SYMBOL_AS_UID$1 && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};

var isCallable$j = isCallable$l;
var $documentAll = documentAll_1;

var documentAll = $documentAll.all;

var isObject$a = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable$j(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable$j(it);
};

var isObject$9 = isObject$a;

var $String$3 = String;
var $TypeError$e = TypeError;

// `Assert: Type(argument) is Object`
var anObject$c = function (argument) {
  if (isObject$9(argument)) return argument;
  throw $TypeError$e($String$3(argument) + ' is not an object');
};

var objectDefineProperties = {};

var fails$c = fails$g;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$c(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var DESCRIPTORS$b = descriptors;
var fails$b = fails$g;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$b && fails$b(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var objectDefineProperty = {};

var global$e = global$k;
var isObject$8 = isObject$a;

var document$3 = global$e.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$8(document$3) && isObject$8(document$3.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};

var DESCRIPTORS$a = descriptors;
var fails$a = fails$g;
var createElement$1 = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$a && !fails$a(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var NATIVE_BIND$2 = functionBindNative;

var call$f = Function.prototype.call;

var functionCall = NATIVE_BIND$2 ? call$f.bind(call$f) : function () {
  return call$f.apply(call$f, arguments);
};

var uncurryThis$a = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$a({}.isPrototypeOf);

var getBuiltIn$6 = getBuiltIn$8;
var isCallable$i = isCallable$l;
var isPrototypeOf$4 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var $Object$2 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$6('Symbol');
  return isCallable$i($Symbol) && isPrototypeOf$4($Symbol.prototype, $Object$2(it));
};

var $String$2 = String;

var tryToString$4 = function (argument) {
  try {
    return $String$2(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$h = isCallable$l;
var tryToString$3 = tryToString$4;

var $TypeError$d = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$8 = function (argument) {
  if (isCallable$h(argument)) return argument;
  throw $TypeError$d(tryToString$3(argument) + ' is not a function');
};

var aCallable$7 = aCallable$8;
var isNullOrUndefined$2 = isNullOrUndefined$4;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$3 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined$2(func) ? undefined : aCallable$7(func);
};

var call$e = functionCall;
var isCallable$g = isCallable$l;
var isObject$7 = isObject$a;

var $TypeError$c = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$g(fn = input.toString) && !isObject$7(val = call$e(fn, input))) return val;
  if (isCallable$g(fn = input.valueOf) && !isObject$7(val = call$e(fn, input))) return val;
  if (pref !== 'string' && isCallable$g(fn = input.toString) && !isObject$7(val = call$e(fn, input))) return val;
  throw $TypeError$c("Can't convert object to primitive value");
};

var call$d = functionCall;
var isObject$6 = isObject$a;
var isSymbol$1 = isSymbol$2;
var getMethod$2 = getMethod$3;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$g = wellKnownSymbol$h;

var $TypeError$b = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$g('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$6(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$2(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$d(exoticToPrim, input, pref);
    if (!isObject$6(result) || isSymbol$1(result)) return result;
    throw $TypeError$b("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var DESCRIPTORS$9 = descriptors;
var IE8_DOM_DEFINE$1 = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$b = anObject$c;
var toPropertyKey$1 = toPropertyKey$2;

var $TypeError$a = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$9 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$b(O);
  P = toPropertyKey$1(P);
  anObject$b(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor$1(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$b(O);
  P = toPropertyKey$1(P);
  anObject$b(Attributes);
  if (IE8_DOM_DEFINE$1) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError$a('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$3 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$2 = toIntegerOrInfinity$3;

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$2(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

var toIntegerOrInfinity$1 = toIntegerOrInfinity$3;

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity$1(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength = toLength$1;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$5 = function (obj) {
  return toLength(obj.length);
};

var toIndexedObject$4 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$4 = lengthOfArrayLike$5;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$1 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$4($this);
    var length = lengthOfArrayLike$4(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$1(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$1(false)
};

var hiddenKeys$4 = {};

var uncurryThis$9 = functionUncurryThis;
var hasOwn$a = hasOwnProperty_1;
var toIndexedObject$3 = toIndexedObject$5;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$3 = hiddenKeys$4;

var push = uncurryThis$9([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$3(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$a(hiddenKeys$3, key) && hasOwn$a(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$a(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys$1(O, enumBugKeys$2);
};

var DESCRIPTORS$8 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$4 = objectDefineProperty;
var anObject$a = anObject$c;
var toIndexedObject$2 = toIndexedObject$5;
var objectKeys$1 = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$8 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$a(O);
  var props = toIndexedObject$2(Properties);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$4.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn$5 = getBuiltIn$8;

var html$2 = getBuiltIn$5('document', 'documentElement');

var shared$1 = shared$3.exports;
var uid = uid$2;

var keys = shared$1('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

/* global ActiveXObject -- old IE, WSH */

var anObject$9 = anObject$c;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys$1 = enumBugKeys$3;
var hiddenKeys$2 = hiddenKeys$4;
var html$1 = html$2;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$2 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$2('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys$1.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys$1[length]];
  return NullProtoObject();
};

hiddenKeys$2[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$9(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$f = wellKnownSymbol$h;
var create$1 = objectCreate;
var defineProperty$5 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$f('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] == undefined) {
  defineProperty$5(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: create$1(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$3 = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};

var iterators = {};

var global$d = global$k;
var isCallable$f = isCallable$l;

var WeakMap$1 = global$d.WeakMap;

var weakMapBasicDetection = isCallable$f(WeakMap$1) && /native code/.test(String(WeakMap$1));

var createPropertyDescriptor$3 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var DESCRIPTORS$7 = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor$2 = createPropertyDescriptor$3;

var createNonEnumerableProperty$4 = DESCRIPTORS$7 ? function (object, key, value) {
  return definePropertyModule$3.f(object, key, createPropertyDescriptor$2(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$c = global$k;
var isObject$5 = isObject$a;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$4;
var hasOwn$9 = hasOwnProperty_1;
var shared = sharedStore;
var sharedKey$1 = sharedKey$3;
var hiddenKeys$1 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$2 = global$c.TypeError;
var WeakMap = global$c.WeakMap;
var set$1, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set$1(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$5(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$2('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store$1 = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store$1.get = store$1.get;
  store$1.has = store$1.has;
  store$1.set = store$1.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set$1 = function (it, metadata) {
    if (store$1.has(it)) throw TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store$1.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store$1.get(it) || {};
  };
  has = function (it) {
    return store$1.has(it);
  };
} else {
  var STATE = sharedKey$1('state');
  hiddenKeys$1[STATE] = true;
  set$1 = function (it, metadata) {
    if (hasOwn$9(it, STATE)) throw TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$3(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$9(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$9(it, STATE);
  };
}

var internalState = {
  set: set$1,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var objectGetOwnPropertyDescriptor = {};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$2 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$2(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var DESCRIPTORS$6 = descriptors;
var call$c = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$1 = createPropertyDescriptor$3;
var toIndexedObject$1 = toIndexedObject$5;
var toPropertyKey = toPropertyKey$2;
var hasOwn$8 = hasOwnProperty_1;
var IE8_DOM_DEFINE = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$6 ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$1(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$8(O, P)) return createPropertyDescriptor$1(!call$c(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var makeBuiltIn$2 = {exports: {}};

var DESCRIPTORS$5 = descriptors;
var hasOwn$7 = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$5 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$7(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$5 || (DESCRIPTORS$5 && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$8 = functionUncurryThis;
var isCallable$e = isCallable$l;
var store = sharedStore;

var functionToString = uncurryThis$8(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$e(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$3 = store.inspectSource;

var fails$9 = fails$g;
var isCallable$d = isCallable$l;
var hasOwn$6 = hasOwnProperty_1;
var DESCRIPTORS$4 = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource$2 = inspectSource$3;
var InternalStateModule$2 = internalState;

var enforceInternalState = InternalStateModule$2.enforce;
var getInternalState$1 = InternalStateModule$2.get;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$4 = Object.defineProperty;

var CONFIGURABLE_LENGTH = DESCRIPTORS$4 && !fails$9(function () {
  return defineProperty$4(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$1 = makeBuiltIn$2.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$6(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$4) defineProperty$4(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$6(options, 'arity') && value.length !== options.arity) {
    defineProperty$4(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$6(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$4) defineProperty$4(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$6(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$1(function toString() {
  return isCallable$d(this) && getInternalState$1(this).source || inspectSource$2(this);
}, 'toString');

var isCallable$c = isCallable$l;
var definePropertyModule$2 = objectDefineProperty;
var makeBuiltIn = makeBuiltIn$2.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$6 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$c(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$2.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys = enumBugKeys$3;

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$4 = getBuiltIn$8;
var uncurryThis$7 = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$8 = anObject$c;

var concat$1 = uncurryThis$7([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$4('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$8(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$5 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$1 = objectDefineProperty;

var copyConstructorProperties$2 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$1.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$5(target, key) && !(exceptions && hasOwn$5(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$8 = fails$g;
var isCallable$b = isCallable$l;

var replacement = /#|\.prototype\./;

var isForced$2 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$b(detection) ? fails$8(detection)
    : !!detection;
};

var normalize = isForced$2.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$2.data = {};
var NATIVE = isForced$2.NATIVE = 'N';
var POLYFILL = isForced$2.POLYFILL = 'P';

var isForced_1 = isForced$2;

var global$b = global$k;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$4;
var defineBuiltIn$5 = defineBuiltIn$6;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced$1 = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$b;
  } else if (STATIC) {
    target = global$b[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global$b[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$2(sourceProperty, 'sham', true);
    }
    defineBuiltIn$5(target, key, sourceProperty, options);
  }
};

var fails$7 = fails$g;

var correctPrototypeGetter = !fails$7(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$4 = hasOwnProperty_1;
var isCallable$a = isCallable$l;
var toObject$3 = toObject$5;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object$1 = Object;
var ObjectPrototype = $Object$1.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object$1.getPrototypeOf : function (O) {
  var object = toObject$3(O);
  if (hasOwn$4(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$a(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object$1 ? ObjectPrototype : null;
};

var fails$6 = fails$g;
var isCallable$9 = isCallable$l;
var isObject$4 = isObject$a;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltIn$4 = defineBuiltIn$6;
var wellKnownSymbol$e = wellKnownSymbol$h;

var ITERATOR$5 = wellKnownSymbol$e('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$4(IteratorPrototype$2) || fails$6(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$5].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$9(IteratorPrototype$2[ITERATOR$5])) {
  defineBuiltIn$4(IteratorPrototype$2, ITERATOR$5, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$3 = objectDefineProperty.f;
var hasOwn$3 = hasOwnProperty_1;
var wellKnownSymbol$d = wellKnownSymbol$h;

var TO_STRING_TAG$3 = wellKnownSymbol$d('toStringTag');

var setToStringTag$3 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$3(target, TO_STRING_TAG$3)) {
    defineProperty$3(target, TO_STRING_TAG$3, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$3;
var setToStringTag$2 = setToStringTag$3;
var Iterators$4 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype$1, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$4[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var isCallable$8 = isCallable$l;

var $String$1 = String;
var $TypeError$9 = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (typeof argument == 'object' || isCallable$8(argument)) return argument;
  throw $TypeError$9("Can't set " + $String$1(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */

var uncurryThis$6 = functionUncurryThis;
var anObject$7 = anObject$c;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis$6(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$7(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$d = _export;
var call$b = functionCall;
var FunctionName = functionName;
var isCallable$7 = isCallable$l;
var createIteratorConstructor = iteratorCreateConstructor;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf$1 = objectSetPrototypeOf;
var setToStringTag$1 = setToStringTag$3;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$4;
var defineBuiltIn$3 = defineBuiltIn$6;
var wellKnownSymbol$c = wellKnownSymbol$h;
var Iterators$3 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME$1 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$4 = wellKnownSymbol$c('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$4]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf$1) {
          setPrototypeOf$1(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$7(CurrentIteratorPrototype[ITERATOR$4])) {
          defineBuiltIn$3(CurrentIteratorPrototype, ITERATOR$4, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$1 && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$1(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$b(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$3(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$d({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$4] !== defaultIterator) {
    defineBuiltIn$3(IterablePrototype, ITERATOR$4, defaultIterator, { name: DEFAULT });
  }
  Iterators$3[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$1 = function (value, done) {
  return { value: value, done: done };
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables$2 = addToUnscopables$3;
var Iterators$2 = iterators;
var InternalStateModule$1 = internalState;
var defineProperty$2 = objectDefineProperty.f;
var defineIterator = iteratorDefine;
var createIterResultObject = createIterResultObject$1;
var DESCRIPTORS$3 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalState = InternalStateModule$1.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  if (kind == 'keys') return createIterResultObject(index, false);
  if (kind == 'values') return createIterResultObject(target[index], false);
  return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators$2.Arguments = Iterators$2.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$2('keys');
addToUnscopables$2('values');
addToUnscopables$2('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$3 && values.name !== 'values') try {
  defineProperty$2(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$a = global$k;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty = createNonEnumerableProperty$4;
var wellKnownSymbol$b = wellKnownSymbol$h;

var ITERATOR$3 = wellKnownSymbol$b('iterator');
var TO_STRING_TAG$2 = wellKnownSymbol$b('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$3] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR$3, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$3] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG$2]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG$2, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$a[COLLECTION_NAME] && global$a[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

var classof$6 = classofRaw$2;
var global$9 = global$k;

var engineIsNode = classof$6(global$9.process) == 'process';

var getBuiltIn$3 = getBuiltIn$8;
var definePropertyModule = objectDefineProperty;
var wellKnownSymbol$a = wellKnownSymbol$h;
var DESCRIPTORS$2 = descriptors;

var SPECIES$3 = wellKnownSymbol$a('species');

var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$3(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS$2 && Constructor && !Constructor[SPECIES$3]) {
    defineProperty(Constructor, SPECIES$3, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var isPrototypeOf$3 = objectIsPrototypeOf;

var $TypeError$8 = TypeError;

var anInstance$1 = function (it, Prototype) {
  if (isPrototypeOf$3(Prototype, it)) return it;
  throw $TypeError$8('Incorrect invocation');
};

var wellKnownSymbol$9 = wellKnownSymbol$h;

var TO_STRING_TAG$1 = wellKnownSymbol$9('toStringTag');
var test = {};

test[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$6 = isCallable$l;
var classofRaw = classofRaw$2;
var wellKnownSymbol$8 = wellKnownSymbol$h;

var TO_STRING_TAG = wellKnownSymbol$8('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$5 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable$6(O.callee) ? 'Arguments' : result;
};

var uncurryThis$5 = functionUncurryThis;
var fails$5 = fails$g;
var isCallable$5 = isCallable$l;
var classof$4 = classof$5;
var getBuiltIn$2 = getBuiltIn$8;
var inspectSource$1 = inspectSource$3;

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn$2('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis$5(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$5(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable$5(argument)) return false;
  switch (classof$4(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource$1(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$2 = !construct || fails$5(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var isConstructor$1 = isConstructor$2;
var tryToString$2 = tryToString$4;

var $TypeError$7 = TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor$1 = function (argument) {
  if (isConstructor$1(argument)) return argument;
  throw $TypeError$7(tryToString$2(argument) + ' is not a constructor');
};

var anObject$6 = anObject$c;
var aConstructor = aConstructor$1;
var isNullOrUndefined$1 = isNullOrUndefined$4;
var wellKnownSymbol$7 = wellKnownSymbol$h;

var SPECIES$2 = wellKnownSymbol$7('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$1 = function (O, defaultConstructor) {
  var C = anObject$6(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined$1(S = anObject$6(C)[SPECIES$2]) ? defaultConstructor : aConstructor(S);
};

var NATIVE_BIND$1 = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$1 = FunctionPrototype.apply;
var call$a = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND$1 ? call$a.bind(apply$1) : function () {
  return call$a.apply(apply$1, arguments);
});

var uncurryThis$4 = functionUncurryThis;
var aCallable$6 = aCallable$8;
var NATIVE_BIND = functionBindNative;

var bind$5 = uncurryThis$4(uncurryThis$4.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$6(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind$5(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var uncurryThis$3 = functionUncurryThis;

var arraySlice$1 = uncurryThis$3([].slice);

var $TypeError$6 = TypeError;

var validateArgumentsLength$1 = function (passed, required) {
  if (passed < required) throw $TypeError$6('Not enough arguments');
  return passed;
};

var userAgent$2 = engineUserAgent;

var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$2);

var global$8 = global$k;
var apply = functionApply;
var bind$4 = functionBindContext;
var isCallable$4 = isCallable$l;
var hasOwn$2 = hasOwnProperty_1;
var fails$4 = fails$g;
var html = html$2;
var arraySlice = arraySlice$1;
var createElement = documentCreateElement$2;
var validateArgumentsLength = validateArgumentsLength$1;
var IS_IOS$1 = engineIsIos;
var IS_NODE$4 = engineIsNode;

var set = global$8.setImmediate;
var clear = global$8.clearImmediate;
var process$2 = global$8.process;
var Dispatch = global$8.Dispatch;
var Function$1 = global$8.Function;
var MessageChannel = global$8.MessageChannel;
var String$1 = global$8.String;
var counter = 0;
var queue$1 = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global$8.location;
} catch (error) { /* empty */ }

var run = function (id) {
  if (hasOwn$2(queue$1, id)) {
    var fn = queue$1[id];
    delete queue$1[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global$8.postMessage(String$1(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable$4(handler) ? handler : Function$1(handler);
    var args = arraySlice(arguments, 1);
    queue$1[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue$1[id];
  };
  // Node.js 0.8-
  if (IS_NODE$4) {
    defer = function (id) {
      process$2.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind$4(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$8.addEventListener &&
    isCallable$4(global$8.postMessage) &&
    !global$8.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails$4(post)
  ) {
    defer = post;
    global$8.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set,
  clear: clear
};

var userAgent$1 = engineUserAgent;
var global$7 = global$k;

var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$1) && global$7.Pebble !== undefined;

var userAgent = engineUserAgent;

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent);

var global$6 = global$k;
var bind$3 = functionBindContext;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var macrotask = task$1.set;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$3 = engineIsNode;

var MutationObserver = global$6.MutationObserver || global$6.WebKitMutationObserver;
var document$2 = global$6.document;
var process$1 = global$6.process;
var Promise$1 = global$6.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global$6, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE$3 && (parent = process$1.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify$1();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$3 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = bind$3(promise.then, promise);
    notify$1 = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE$3) {
    notify$1 = function () {
      process$1.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // strange IE + webpack dev server bug - use .bind(global)
    macrotask = bind$3(macrotask, global$6);
    notify$1 = function () {
      macrotask(flush);
    };
  }
}

var microtask$1 = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify$1();
  } last = task;
};

var global$5 = global$k;

var hostReportErrors$1 = function (a, b) {
  var console = global$5.console;
  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};

var perform$3 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var Queue$1 = function () {
  this.head = null;
  this.tail = null;
};

Queue$1.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    if (this.head) this.tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      this.head = entry.next;
      if (this.tail === entry) this.tail = null;
      return entry.item;
    }
  }
};

var queue = Queue$1;

var global$4 = global$k;

var promiseNativeConstructor = global$4.Promise;

/* global Deno -- Deno case */

var engineIsDeno = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';

var IS_DENO$1 = engineIsDeno;
var IS_NODE$2 = engineIsNode;

var engineIsBrowser = !IS_DENO$1 && !IS_NODE$2
  && typeof window == 'object'
  && typeof document == 'object';

var global$3 = global$k;
var NativePromiseConstructor$3 = promiseNativeConstructor;
var isCallable$3 = isCallable$l;
var isForced = isForced_1;
var inspectSource = inspectSource$3;
var wellKnownSymbol$6 = wellKnownSymbol$h;
var IS_BROWSER = engineIsBrowser;
var IS_DENO = engineIsDeno;
var V8_VERSION = engineV8Version;

NativePromiseConstructor$3 && NativePromiseConstructor$3.prototype;
var SPECIES$1 = wellKnownSymbol$6('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT$1 = isCallable$3(global$3.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR$5 = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor$3);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor$3);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor$3(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES$1] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT$1;
});

var promiseConstructorDetection = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$5,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$1,
  SUBCLASSING: SUBCLASSING
};

var newPromiseCapability$2 = {};

var aCallable$5 = aCallable$8;

var $TypeError$5 = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw $TypeError$5('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$5(resolve);
  this.reject = aCallable$5(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var $$c = _export;
var IS_NODE$1 = engineIsNode;
var global$2 = global$k;
var call$9 = functionCall;
var defineBuiltIn$2 = defineBuiltIn$6;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag = setToStringTag$3;
var setSpecies = setSpecies$1;
var aCallable$4 = aCallable$8;
var isCallable$2 = isCallable$l;
var isObject$3 = isObject$a;
var anInstance = anInstance$1;
var speciesConstructor = speciesConstructor$1;
var task = task$1.set;
var microtask = microtask$1;
var hostReportErrors = hostReportErrors$1;
var perform$2 = perform$3;
var Queue = queue;
var InternalStateModule = internalState;
var NativePromiseConstructor$2 = promiseNativeConstructor;
var PromiseConstructorDetection = promiseConstructorDetection;
var newPromiseCapabilityModule$3 = newPromiseCapability$2;

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$4 = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype$1 = NativePromiseConstructor$2 && NativePromiseConstructor$2.prototype;
var PromiseConstructor = NativePromiseConstructor$2;
var PromisePrototype = NativePromisePrototype$1;
var TypeError$1 = global$2.TypeError;
var document$1 = global$2.document;
var process = global$2.process;
var newPromiseCapability$1 = newPromiseCapabilityModule$3.f;
var newGenericPromiseCapability = newPromiseCapability$1;

var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$2.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject$3(it) && isCallable$2(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError$1('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call$9(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$2.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global$2['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call$9(task, global$2, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform$2(function () {
        if (IS_NODE$1) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE$1 || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call$9(task, global$2, function () {
    var promise = state.facade;
    if (IS_NODE$1) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$2 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError$1("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call$9(then, value,
            bind$2(internalResolve, wrapper, state),
            bind$2(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR$4) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable$4(executor);
    call$9(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind$2(internalResolve, state), bind$2(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn$2(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability$1(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable$2(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable$2(onRejected) && onRejected;
    reaction.domain = IS_NODE$1 ? process.domain : undefined;
    if (state.state == PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind$2(internalResolve, state);
    this.reject = bind$2(internalReject, state);
  };

  newPromiseCapabilityModule$3.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (isCallable$2(NativePromiseConstructor$2) && NativePromisePrototype$1 !== Object.prototype) {
    nativeThen = NativePromisePrototype$1.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn$2(NativePromisePrototype$1, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call$9(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype$1.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype$1, PromisePrototype);
    }
  }
}

$$c({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR$4 }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);

var wellKnownSymbol$5 = wellKnownSymbol$h;
var Iterators$1 = iterators;

var ITERATOR$2 = wellKnownSymbol$5('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (Iterators$1.Array === it || ArrayPrototype[ITERATOR$2] === it);
};

var classof$3 = classof$5;
var getMethod$1 = getMethod$3;
var isNullOrUndefined = isNullOrUndefined$4;
var Iterators = iterators;
var wellKnownSymbol$4 = wellKnownSymbol$h;

var ITERATOR$1 = wellKnownSymbol$4('iterator');

var getIteratorMethod$2 = function (it) {
  if (!isNullOrUndefined(it)) return getMethod$1(it, ITERATOR$1)
    || getMethod$1(it, '@@iterator')
    || Iterators[classof$3(it)];
};

var call$8 = functionCall;
var aCallable$3 = aCallable$8;
var anObject$5 = anObject$c;
var tryToString$1 = tryToString$4;
var getIteratorMethod$1 = getIteratorMethod$2;

var $TypeError$4 = TypeError;

var getIterator$1 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$1(argument) : usingIterator;
  if (aCallable$3(iteratorMethod)) return anObject$5(call$8(iteratorMethod, argument));
  throw $TypeError$4(tryToString$1(argument) + ' is not iterable');
};

var call$7 = functionCall;
var anObject$4 = anObject$c;
var getMethod = getMethod$3;

var iteratorClose$1 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$4(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$7(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$4(innerResult);
  return value;
};

var bind$1 = functionBindContext;
var call$6 = functionCall;
var anObject$3 = anObject$c;
var tryToString = tryToString$4;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var lengthOfArrayLike$3 = lengthOfArrayLike$5;
var isPrototypeOf$2 = objectIsPrototypeOf;
var getIterator = getIterator$1;
var getIteratorMethod = getIteratorMethod$2;
var iteratorClose = iteratorClose$1;

var $TypeError$3 = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate$2 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind$1(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$3(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw $TypeError$3(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike$3(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf$2(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call$6(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf$2(ResultPrototype, result)) return result;
  } return new Result(false);
};

var wellKnownSymbol$3 = wellKnownSymbol$h;

var ITERATOR = wellKnownSymbol$3('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var NativePromiseConstructor$1 = promiseNativeConstructor;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;

var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$3 || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor$1.all(iterable).then(undefined, function () { /* empty */ });
});

var $$b = _export;
var call$5 = functionCall;
var aCallable$2 = aCallable$8;
var newPromiseCapabilityModule$2 = newPromiseCapability$2;
var perform$1 = perform$3;
var iterate$1 = iterate$2;
var PROMISE_STATICS_INCORRECT_ITERATION$1 = promiseStaticsIncorrectIteration;

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$$b({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION$1 }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$2.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aCallable$2(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate$1(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call$5($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$a = _export;
var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;
var NativePromiseConstructor = promiseNativeConstructor;
var getBuiltIn$1 = getBuiltIn$8;
var isCallable$1 = isCallable$l;
var defineBuiltIn$1 = defineBuiltIn$6;

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$$a({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR$2, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (isCallable$1(NativePromiseConstructor)) {
  var method = getBuiltIn$1('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn$1(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}

var $$9 = _export;
var call$4 = functionCall;
var aCallable$1 = aCallable$8;
var newPromiseCapabilityModule$1 = newPromiseCapability$2;
var perform = perform$3;
var iterate = iterate$2;
var PROMISE_STATICS_INCORRECT_ITERATION = promiseStaticsIncorrectIteration;

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$$9({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$1.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable$1(C.resolve);
      iterate(iterable, function (promise) {
        call$4($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$8 = _export;
var call$3 = functionCall;
var newPromiseCapabilityModule = newPromiseCapability$2;
var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$$8({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR$1 }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    call$3(capability.reject, undefined, r);
    return capability.promise;
  }
});

var anObject$2 = anObject$c;
var isObject$2 = isObject$a;
var newPromiseCapability = newPromiseCapability$2;

var promiseResolve$1 = function (C, x) {
  anObject$2(C);
  if (isObject$2(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var $$7 = _export;
var getBuiltIn = getBuiltIn$8;
var FORCED_PROMISE_CONSTRUCTOR = promiseConstructorDetection.CONSTRUCTOR;
var promiseResolve = promiseResolve$1;

getBuiltIn('Promise');

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$$7({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});

let currentlyLoadingMapsApi;
const loadedMapsLibraries = new Map();
class GoogleMapsLoader {
  constructor(apiKey = null, options = {}) {
    this.apiKey = void 0;
    this.options = void 0;
    this.apiKey = apiKey;
    this.options = options;
    if (!window) {
      throw new Error('google-maps is supported only in browser environment');
    }
  }
  async loadMapsApi() {
    var _window$google, _window$google$maps;
    if (typeof ((_window$google = window.google) == null ? void 0 : (_window$google$maps = _window$google.maps) == null ? void 0 : _window$google$maps.importLibrary) === 'function') {
      return new Promise(resolve => resolve(window.google));
    }
    if (!currentlyLoadingMapsApi) {
      currentlyLoadingMapsApi = new Promise((resolve, reject) => {
        window.initMap = () => {
          resolve(window.google);
          currentlyLoadingMapsApi = undefined;
          delete window.initMap;
        };
        window.gm_authFailure = () => {
          reject(new Error('google-maps: authentication error'));
          delete window.gm_authFailure;
        };
        const script = document.createElement('script');
        script.src = this.createUrl();
        script.async = true;
        script.onerror = e => reject(e);
        document.head.appendChild(script);
      });
    }
    return currentlyLoadingMapsApi;
  }
  createUrl() {
    const parameters = ['callback=initMap', 'loading=async'];
    if (this.apiKey) {
      parameters.push(`key=${this.apiKey}`);
    }
    if (this.options.language) {
      parameters.push('language=' + this.options.language);
    }
    if (this.options.version) {
      parameters.push(`v=${this.options.version}`);
    }
    if (this.options.client) {
      parameters.push(`client=${this.options.client}`);
    }
    if (this.options.channel) {
      parameters.push(`channel=${this.options.channel}`);
    }
    if (this.options.region) {
      parameters.push(`region=${this.options.region}`);
    }
    return `https://maps.googleapis.com/maps/api/js?${parameters.join('&')}`;
  }
  async loadLibrary(libraryName) {
    const existingLibrary = loadedMapsLibraries.get(libraryName);
    if (existingLibrary) {
      return existingLibrary;
    }
    const importProcess = this.loadMapsApi().then(googleObj => googleObj.maps.importLibrary(libraryName).then(importedLibrary => {
      loadedMapsLibraries.set(libraryName, Promise.resolve(importedLibrary));
      return importedLibrary;
    }).catch(error => {
      loadedMapsLibraries.delete(libraryName);
      throw error;
    })).catch(error => {
      throw error;
    });
    loadedMapsLibraries.set(libraryName, importProcess);
    return importProcess;
  }
}

var classof$2 = classof$5;

var $String = String;

var toString$2 = function (argument) {
  if (classof$2(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

var anObject$1 = anObject$c;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags = function () {
  var that = anObject$1(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var call$2 = functionCall;
var hasOwn$1 = hasOwnProperty_1;
var isPrototypeOf$1 = objectIsPrototypeOf;
var regExpFlags = regexpFlags;

var RegExpPrototype$1 = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$1) && !hasOwn$1(R, 'flags') && isPrototypeOf$1(RegExpPrototype$1, R)
    ? call$2(regExpFlags, R) : flags;
};

var PROPER_FUNCTION_NAME = functionName.PROPER;
var defineBuiltIn = defineBuiltIn$6;
var anObject = anObject$c;
var $toString = toString$2;
var fails$3 = fails$g;
var getRegExpFlags = regexpGetFlags;

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails$3(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

var $$6 = _export;
var $includes = arrayIncludes.includes;
var fails$2 = fails$g;
var addToUnscopables$1 = addToUnscopables$3;

// FF99+ bug
var BROKEN_ON_SPARSE = fails$2(function () {
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$6({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('includes');

var isObject$1 = isObject$a;
var classof$1 = classofRaw$2;
var wellKnownSymbol$2 = wellKnownSymbol$h;

var MATCH$1 = wellKnownSymbol$2('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$1(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof$1(it) == 'RegExp');
};

var isRegExp = isRegexp;

var $TypeError$2 = TypeError;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw $TypeError$2("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$1 = wellKnownSymbol$h;

var MATCH = wellKnownSymbol$1('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $$5 = _export;
var uncurryThis$2 = functionUncurryThis;
var notARegExp = notARegexp;
var requireObjectCoercible = requireObjectCoercible$3;
var toString$1 = toString$2;
var correctIsRegExpLogic = correctIsRegexpLogic;

var stringIndexOf = uncurryThis$2(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$5({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString$1(requireObjectCoercible(this)),
      toString$1(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

const GOOGLE_TEST_KEY = 'AIzaSyCTqN5UrrqK-aaJw5MeqoW2JRWh4RHMBRU';
const GOOGLE_PROD_KEY = 'AIzaSyA7qghFGBNo-DxGTTWoY0WDd4Ho7v5rdmo';
const GOOGLE_PROD_STATIC_MAP_API_KEY = 'AIzaSyACis1Gu7CIYhDa_zJ3VhTMe14PLUVUqP0';
const GOOGLE_STATIC_API_KEY = window.location.origin.includes('localhost') ? GOOGLE_TEST_KEY : GOOGLE_PROD_STATIC_MAP_API_KEY;
const GOOGLE_API_KEY = window.location.origin.includes('localhost') || window.location.origin.includes('bs-local') ? GOOGLE_TEST_KEY : GOOGLE_PROD_KEY;
const TRIPPLANNER_MAP_ID = '392caa6a8fe9926e';

var aCallable = aCallable$8;
var toObject$2 = toObject$5;
var IndexedObject$1 = indexedObject;
var lengthOfArrayLike$2 = lengthOfArrayLike$5;

var $TypeError$1 = TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject$2(that);
    var self = IndexedObject$1(O);
    var length = lengthOfArrayLike$2(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw $TypeError$1('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};

var fails$1 = fails$g;

var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$1(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

var $$4 = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict = arrayMethodIsStrict$1;
var CHROME_VERSION = engineV8Version;
var IS_NODE = engineIsNode;

var STRICT_METHOD = arrayMethodIsStrict('reduce');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$$4({ target: 'Array', proto: true, forced: !STRICT_METHOD || CHROME_BUG }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});

const existingMapParents = [];
function trackMapLoad(mapParent) {
  const clonedMapParent = mapParent.cloneNode();
  const mapParentExists = existingMapParents.some(existingMapParent => clonedMapParent.isEqualNode(existingMapParent));
  const eventName = mapParentExists ? 'mapReload' : 'mapLoad';
  if (!mapParentExists) {
    existingMapParents.push(clonedMapParent);
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName
  });
  log(eventName);
}

var classof = classofRaw$2;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$2 = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

var doesNotExceedSafeInteger$1 = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};

var isArray$1 = isArray$2;
var lengthOfArrayLike$1 = lengthOfArrayLike$5;
var doesNotExceedSafeInteger = doesNotExceedSafeInteger$1;
var bind = functionBindContext;

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray$1 = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind(mapper, thisArg) : false;
  var element, elementLen;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray$1(element)) {
        elementLen = lengthOfArrayLike$1(element);
        targetIndex = flattenIntoArray$1(target, original, element, elementLen, targetIndex, depth - 1) - 1;
      } else {
        doesNotExceedSafeInteger(targetIndex + 1);
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

var flattenIntoArray_1 = flattenIntoArray$1;

var isArray = isArray$2;
var isConstructor = isConstructor$2;
var isObject = isObject$a;
var wellKnownSymbol = wellKnownSymbol$h;

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor$1 = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};

var arraySpeciesConstructor = arraySpeciesConstructor$1;

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$1 = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

var $$3 = _export;
var flattenIntoArray = flattenIntoArray_1;
var toObject$1 = toObject$5;
var lengthOfArrayLike = lengthOfArrayLike$5;
var toIntegerOrInfinity = toIntegerOrInfinity$3;
var arraySpeciesCreate = arraySpeciesCreate$1;

// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
$$3({ target: 'Array', proto: true }, {
  flat: function flat(/* depthArg = 1 */) {
    var depthArg = arguments.length ? arguments[0] : undefined;
    var O = toObject$1(this);
    var sourceLen = lengthOfArrayLike(O);
    var A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toIntegerOrInfinity(depthArg));
    return A;
  }
});

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = addToUnscopables$3;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flat');

var DESCRIPTORS$1 = descriptors;
var uncurryThis$1 = functionUncurryThis;
var call$1 = functionCall;
var fails = fails$g;
var objectKeys = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject = toObject$5;
var IndexedObject = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$1 = Object.defineProperty;
var concat = uncurryThis$1([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$1 && $assign({ b: 1 }, $assign(defineProperty$1({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$1(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$1 || call$1(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$2 = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$2({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

var ConnectionType;
(function (ConnectionType) {
  ConnectionType[ConnectionType["NONE"] = 0] = "NONE";
  ConnectionType[ConnectionType["CAR"] = 1] = "CAR";
  ConnectionType[ConnectionType["WALK"] = 2] = "WALK";
  ConnectionType[ConnectionType["BICYCLE"] = 3] = "BICYCLE";
  ConnectionType[ConnectionType["FLIGHT"] = 4] = "FLIGHT";
  ConnectionType[ConnectionType["FERRY"] = 5] = "FERRY";
})(ConnectionType || (ConnectionType = {}));

function getConnectionType(marker) {
  var _marker$data$connecti;
  if (!marker.data || typeof marker.data === 'string') {
    return ConnectionType.NONE;
  }
  return (_marker$data$connecti = marker.data.connectionToBeReached) != null ? _marker$data$connecti : ConnectionType.NONE;
}
function getRouteSegmentsByConnectionType(route) {
  return route.reduce((routeSegmentsByConnectionType, currentRouteConnection, index) => {
    if (index === 0) {
      routeSegmentsByConnectionType.push({
        segment: [currentRouteConnection],
        type: currentRouteConnection.type
      });
    } else {
      const previousRouteConnection = route[index - 1];
      if (previousRouteConnection.type === currentRouteConnection.type && previousRouteConnection.to.key === currentRouteConnection.from.key) {
        const lastRouteSegment = last$1(routeSegmentsByConnectionType);
        lastRouteSegment == null ? void 0 : lastRouteSegment.segment.push(currentRouteConnection);
      } else {
        routeSegmentsByConnectionType.push({
          segment: [currentRouteConnection],
          type: currentRouteConnection.type
        });
      }
    }
    return routeSegmentsByConnectionType;
  }, []);
}
function getRouteSegmentBoundaries(routeSegment) {
  var _routeSegment$segment, _routeSegment$segment2;
  const from = (_routeSegment$segment = routeSegment.segment[0]) == null ? void 0 : _routeSegment$segment.from;
  const to = (_routeSegment$segment2 = routeSegment.segment[routeSegment.segment.length - 1]) == null ? void 0 : _routeSegment$segment2.to;
  if (!from || !to) {
    throw new Error('Trying to get boundaries from empty segment.');
  }
  const waypoints = getWaypointsFromSegment(routeSegment.segment);
  return {
    from,
    to,
    waypoints,
    type: routeSegment.type
  };
}
function getWaypointsFromSegment(segment) {
  return segment.slice(0, -1).map(connection => connection.to);
}
function isRoutableConnectionType(connectionType) {
  return [ConnectionType.CAR, ConnectionType.BICYCLE, ConnectionType.WALK].includes(connectionType);
}
function getDirectionsRequest(segmentBoundaries) {
  const origin = new google.maps.LatLng(segmentBoundaries.from.position.latitude, segmentBoundaries.from.position.longitude);
  const destination = new google.maps.LatLng(segmentBoundaries.to.position.latitude, segmentBoundaries.to.position.longitude);
  const googleWaypoints = segmentBoundaries.waypoints.map(waypoint => ({
    location: new google.maps.LatLng(waypoint.position.latitude, waypoint.position.longitude),
    stopover: true
  }));
  return {
    origin,
    destination,
    waypoints: googleWaypoints,
    travelMode: getGoogleMapsTravelMode(segmentBoundaries.type)
  };
}
function getGoogleMapsTravelMode(connectionType) {
  switch (connectionType) {
    case ConnectionType.CAR:
      return google.maps.TravelMode.DRIVING;
    case ConnectionType.WALK:
      return google.maps.TravelMode.WALKING;
    case ConnectionType.BICYCLE:
      return google.maps.TravelMode.BICYCLING;
    //TODO: Change custom ConnectionTypes withouth using google.maps.TravelMode
    case ConnectionType.NONE:
      return google.maps.TravelMode.WALKING;
    case ConnectionType.FLIGHT:
      return google.maps.TravelMode.DRIVING;
    case ConnectionType.FERRY:
      return google.maps.TravelMode.DRIVING;
    default:
      return google.maps.TravelMode.DRIVING;
  }
}
function getRouteWithDetailsFromDirectionsResult(result, segmentBoundaries) {
  const allSegmentMarkers = [segmentBoundaries.from, ...segmentBoundaries.waypoints, segmentBoundaries.to];
  const route = result.routes[0];
  return route.legs.map((leg, index) => {
    var _leg$distance, _leg$duration;
    const distanceInMeters = (_leg$distance = leg.distance) == null ? void 0 : _leg$distance.value;
    const timeInSeconds = (_leg$duration = leg.duration) == null ? void 0 : _leg$duration.value;
    const distanceInKilometers = distanceInMeters ? distanceInMeters / 1000 : undefined;
    const expectedTravelTimeInMinutes = timeInSeconds ? timeInSeconds / 60 : undefined;
    const fromMarker = allSegmentMarkers[index];
    const toMarker = allSegmentMarkers[index + 1];
    const connection = segmentBoundaries.type;
    return {
      distanceInKilometers,
      expectedTravelTimeInMinutes,
      type: connection,
      from: Object.assign({}, fromMarker),
      to: Object.assign({}, toMarker)
    };
  });
}

class RouteCache {
  // Properties

  constructor() {
    this.cachedRoutes = {};
    if (RouteCache.instance) {
      throw new Error('RouteCache has already been instantiated.');
    }
  }
  // Methods
  static getInstance() {
    if (!RouteCache.instance) {
      RouteCache.instance = new RouteCache();
    }
    return RouteCache.instance;
  }
  addRouteInCache(route, result) {
    const routeId = this.generateRouteId(route);
    this.cachedRoutes[routeId] = result;
  }
  getRouteFromCache(route) {
    const routeId = this.generateRouteId(route);
    return this.cachedRoutes[routeId];
  }
  generateRouteId(route) {
    const transportId = String(getConnectionType(route.to));
    const fromMarkerId = this.generateMarkerId(route.from);
    const toMarkerId = this.generateMarkerId(route.to);
    const waypointsIds = route.waypoints.map(this.generateMarkerId).join('wp');
    return `tr:${transportId}fr:${fromMarkerId}to:${toMarkerId}wp:${waypointsIds}`;
  }
  generateMarkerId(marker) {
    const coordinates = marker.position;
    return `${coordinates.latitude}:${coordinates.longitude}`;
  }
}
RouteCache.instance = void 0;

class DirectionsService {
  constructor(language = 'en') {
    this.loadedService = void 0;
    this.routeCache = RouteCache.getInstance();
    this.loadedService = new Promise((resolve, reject) => {
      const loader = new GoogleMapsLoader(GOOGLE_API_KEY, {
        language
      });
      loader.loadLibrary('routes').then(({
        DirectionsService
      }) => resolve(new DirectionsService())).catch(error => reject(error));
    });
  }
  async calculateRoute(route) {
    var _this = this;
    const routeSegmentsByConnectionType = getRouteSegmentsByConnectionType(route);
    const routeSegmentsBoundaries = routeSegmentsByConnectionType.map(getRouteSegmentBoundaries);
    const calculatedRoutesRequests = routeSegmentsBoundaries.map(async function (segmentBoundaries) {
      return await _this.getRouteWithDetails(segmentBoundaries);
    });
    const calculatedRoutesResults = await Promise.all(calculatedRoutesRequests);
    return calculatedRoutesResults.flat();
  }
  async getRouteWithDetails(segmentBoundaries) {
    if (!isRoutableConnectionType(segmentBoundaries.type)) {
      return Promise.resolve([{
        from: segmentBoundaries.from,
        to: segmentBoundaries.to,
        type: segmentBoundaries.type,
        expectedTravelTimeInMinutes: undefined,
        distanceInKilometers: undefined
      }]);
    }
    const cachedResult = this.routeCache.getRouteFromCache(segmentBoundaries);
    if (cachedResult) {
      return Promise.resolve(getRouteWithDetailsFromDirectionsResult(cachedResult, segmentBoundaries));
    }
    const request = getDirectionsRequest(segmentBoundaries);
    const service = await this.loadedService;
    return new Promise((resolve, reject) => {
      service.route(request, (result, status) => {
        if (status === google.maps.DirectionsStatus.OK && result) {
          this.routeCache.addRouteInCache(segmentBoundaries, result);
          resolve(getRouteWithDetailsFromDirectionsResult(result, segmentBoundaries));
        } else {
          reject(new Error(`Route was not successful for the following reason: ${status}`));
        }
      });
    });
  }
}

var MapControl;
(function (MapControl) {
  MapControl[MapControl["zoomControl"] = 0] = "zoomControl";
  MapControl[MapControl["mapTypeControl"] = 1] = "mapTypeControl";
  MapControl[MapControl["scaleControl"] = 2] = "scaleControl";
  MapControl[MapControl["streetViewControl"] = 3] = "streetViewControl";
  MapControl[MapControl["rotateControl"] = 4] = "rotateControl";
  MapControl[MapControl["fullscreenControl"] = 5] = "fullscreenControl";
})(MapControl || (MapControl = {}));
var MapIntegrationType;
(function (MapIntegrationType) {
  MapIntegrationType[MapIntegrationType["GoogleMaps"] = 0] = "GoogleMaps";
  MapIntegrationType[MapIntegrationType["MapKit"] = 1] = "MapKit";
})(MapIntegrationType || (MapIntegrationType = {}));
var MapType;
(function (MapType) {
  MapType["Dynamic"] = "Dynamic";
  MapType["Static"] = "Static";
})(MapType || (MapType = {}));
class StaticMap {
  constructor(integration) {
    this.integration = void 0;
    this.integration = integration;
  }
}
class Map$1 {
  constructor(integration) {
    this.integration = void 0;
    this.isMovingMapInCodeCounter = 0;
    this.existingMarkers = {};
    this.existingRoute = void 0;
    this.integration = integration;
  }
  get viewChanged() {
    return this.integration.viewChanged.pipe(map(x => ({
      newView: x.rectangle,
      userInitiated: this.isMovingMapInCodeCounter === 0,
      zoom: x.zoom
    })));
  }
  getBoundingRectangle() {
    return this.integration.getBoundingRectangle();
  }
  async center(rectangle) {
    this.isMovingMapInCodeCounter++;
    await this.integration.center(rectangle);
    this.isMovingMapInCodeCounter--;
  }
  destroy() {
    this.integration.destroy();
  }
  setMarkers(markers, showAllMarkers, listeners, clusterOptions) {
    const indexedNewMarkers = keyBy(markers, marker => marker.key + marker.cluster);
    log('Begin setting markers', indexedNewMarkers);
    let thereAreDifferentMarkers = false;
    for (const markerKey in this.existingMarkers) {
      if (!(markerKey + this.existingMarkers[markerKey].marker.cluster in indexedNewMarkers)) {
        log('Removing marker', {
          key: markerKey
        });
        thereAreDifferentMarkers = true;
        this.integration.removeMarker(this.existingMarkers[markerKey].mapMarker);
        delete this.existingMarkers[markerKey];
      }
    }
    for (const marker of markers) {
      if (!(marker.key in this.existingMarkers)) {
        log('Adding marker', {
          key: marker.key
        });
        thereAreDifferentMarkers = true;
        const mapMarker = this.integration.addMarker(marker, listeners, clusterOptions);
        this.existingMarkers[marker.key] = {
          marker,
          mapMarker
        };
      } else {
        const existingMarker = this.existingMarkers[marker.key];
        const isDifferentMarkerContent = !isEqual(existingMarker.marker, marker);
        if (isDifferentMarkerContent) {
          log('Replacing marker', {
            key: marker.key
          });
          const newMapMarker = this.integration.replaceMarker(existingMarker.mapMarker, marker, listeners);
          this.existingMarkers[marker.key] = {
            marker,
            mapMarker: newMapMarker
          };
        }
      }
    }
    if (showAllMarkers && thereAreDifferentMarkers) {
      this.showAllMarkers();
    }
    log('End setting markers', this.existingMarkers);
  }
  isExistingRoute(route) {
    if (!this.existingRoute || this.existingRoute.length === 0) {
      return false;
    }
    const newRouteKey = this.getRouteKey(route);
    const existingRouteKey = this.getRouteKey(this.existingRoute);
    return newRouteKey === existingRouteKey;
  }
  getRouteKey(route) {
    return route.reduce((accumulatedKey, connection) => accumulatedKey += `${JSON.stringify(connection.from.position)}-${JSON.stringify(connection.to.position)}-${connection.type}`, '');
  }
  clearRoutes() {
    this.integration.clearRoutes();
  }
  async addRoute(route) {
    var _this = this;
    if (!route.length) {
      this.existingRoute = [];
      return;
    }
    const routeInSegmentsByConnection = this.getRouteInSegmentsByConnection(route);
    const promises = routeInSegmentsByConnection.map(async function (segment) {
      const firstConnection = segment[0].type;
      switch (firstConnection) {
        case ConnectionType.NONE:
          return [];
        case ConnectionType.FERRY:
        case ConnectionType.FLIGHT:
          {
            segment.forEach(pieceOfSegment => {
              _this.integration.addLine(pieceOfSegment.from.position, pieceOfSegment.to.position);
            });
            return [];
          }
        default:
          {
            const from = segment[0].from;
            const to = segment[segment.length - 1].to;
            const waypoints = _this.getWayPointsFromSegment(segment);
            return await _this.integration.addRoute(from, to, waypoints);
          }
      }
    });
    const awaitedPromises = await Promise.all(promises);
    const result = flatten(awaitedPromises);
    this.existingRoute = result;
  }
  getWayPointsFromSegment(segment) {
    const waypoints = [];
    if (segment.length > 1) {
      for (let i = 0; i < segment.length - 1; i++) {
        waypoints.push(segment[i].to);
      }
    }
    return waypoints;
  }
  getRouteInSegmentsByConnection(route) {
    return route.reduce((connectionsInSegments, connection) => {
      if (!connectionsInSegments.length || this.latestConnectionOrConnectionTypeStoredDoNotMatchWithCurrent(connectionsInSegments, connection)) {
        connectionsInSegments.push([]);
      }
      connectionsInSegments[connectionsInSegments.length - 1].push(connection);
      return connectionsInSegments;
    }, []);
  }
  latestConnectionOrConnectionTypeStoredDoNotMatchWithCurrent(connectionsInSegmentsByType, currentConnection) {
    const lastSegmentIndex = connectionsInSegmentsByType.length - 1;
    const lastConnectionInLastSegmentIndex = connectionsInSegmentsByType[lastSegmentIndex].length - 1;
    const lastConnection = connectionsInSegmentsByType[lastSegmentIndex][lastConnectionInLastSegmentIndex];
    return lastConnection.type !== currentConnection.type || lastConnection.to.key !== currentConnection.from.key;
  }
  async showAllMarkers() {
    this.isMovingMapInCodeCounter++;
    const mapMarkers = map$1(this.existingMarkers, x => x.mapMarker);
    await this.integration.showMarkers(mapMarkers);
    this.isMovingMapInCodeCounter--;
  }
}
async function createMap(mapIntegration, element, options) {
  trackMapLoad(element);
  return new Map$1(await mapIntegration.createDynamicMapIntegration(element, options));
}
async function createStaticMap(mapIntegration, element, options) {
  trackMapLoad(element);
  return new StaticMap(await mapIntegration.createMap(element, options));
}

const GOOGLE_MAP_ID_BASE = 'google-map';
let numberOfinstances = 0;
function getSingleMapContainer() {
  for (let mapId = 0; mapId < numberOfinstances; mapId++) {
    const googleMapElement = document.getElementById(`${GOOGLE_MAP_ID_BASE}-${mapId}`);
    if (googleMapElement && googleMapElement.parentNode === document.body) {
      return googleMapElement;
    }
  }
  return null;
}
function setSingleMapContainer() {
  const mapContainer = document.createElement('div');
  mapContainer.classList.add(GOOGLE_MAP_ID_BASE);
  mapContainer.id = `${GOOGLE_MAP_ID_BASE}-${numberOfinstances}`;
  return mapContainer;
}
function setGoogleMapInstance(googleMapElement, options) {
  const googleMapOptions = options ? getGoogleMapOptions(options) : undefined;
  if (googleMapOptions) {
    googleMapOptions['mapId'] = TRIPPLANNER_MAP_ID;
  }
  numberOfinstances++;
  return new google.maps.Map(googleMapElement, googleMapOptions);
}
function updateMapInstanceOptions(googleMapInstance, options) {
  if (!options) {
    return;
  }
  const googleMapOptions = getGoogleMapOptions(options);
  googleMapInstance.setOptions(googleMapOptions);
}
function putMapInContainer(container, mapElement) {
  mapElement.style.display = 'block';
  container.appendChild(mapElement);
}
function putMapInBody(googleMapElement) {
  googleMapElement.style.display = 'none';
  document.body.appendChild(googleMapElement);
}
function getGoogleMapOptions(options) {
  var _options$gestureHandl;
  return {
    clickableIcons: false,
    gestureHandling: (_options$gestureHandl = options == null ? void 0 : options.gestureHandling) != null ? _options$gestureHandl : 'auto',
    zoomControl: options == null ? void 0 : options.mapControls.includes(MapControl.zoomControl),
    mapTypeControl: options == null ? void 0 : options.mapControls.includes(MapControl.mapTypeControl),
    scaleControl: options == null ? void 0 : options.mapControls.includes(MapControl.scaleControl),
    streetViewControl: options == null ? void 0 : options.mapControls.includes(MapControl.streetViewControl),
    rotateControl: options == null ? void 0 : options.mapControls.includes(MapControl.rotateControl),
    fullscreenControl: options == null ? void 0 : options.mapControls.includes(MapControl.fullscreenControl)
  };
}

const defaultMarkerFormatter = (marker, {
  integration
}) => {
  const div = document.createElement('div');
  div.className = marker.cssClass || '';
  if (integration === 'google') {
    div.classList.add('google-overlay-marker');
  }
  if (marker.markerText) {
    const textContainer = document.createElement('span');
    textContainer.textContent = marker.markerText;
    textContainer.className = 'marker-text';
    div.appendChild(textContainer);
  }
  return div;
};
const defaultClusterMarkerFormatter = (marker, cluster, {
  integration
}) => {
  const div = document.createElement('div');
  div.className = marker.cssClass || '';
  if (integration === 'google') {
    div.classList.add('google-overlay-cluster-marker');
  }
  const textContainer = document.createElement('span');
  textContainer.textContent = `${cluster.count}`;
  textContainer.className = 'cluster-marker-text';
  div.appendChild(textContainer);
  return div;
};

var $$1 = _export;
var call = functionCall;

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$$1({ target: 'URL', proto: true, enumerable: true }, {
  toJSON: function toJSON() {
    return call(URL.prototype.toString, this);
  }
});

const getPointPositionOnQuadraticBezierCurve = (start, control, end, segmentPointPosition) => {
  const StartPointMultiplier = segmentPointPosition => {
    return (1 - segmentPointPosition) * (1 - segmentPointPosition);
  };
  const ControlPointMultiplier = segmentPointPosition => {
    return 2 * segmentPointPosition * (1 - segmentPointPosition);
  };
  const EndPointMultiplier = segmentPointPosition => {
    return segmentPointPosition * segmentPointPosition;
  };
  return {
    latitude: StartPointMultiplier(segmentPointPosition) * start.latitude + ControlPointMultiplier(segmentPointPosition) * control.latitude + EndPointMultiplier(segmentPointPosition) * end.latitude,
    longitude: StartPointMultiplier(segmentPointPosition) * start.longitude + ControlPointMultiplier(segmentPointPosition) * control.longitude + EndPointMultiplier(segmentPointPosition) * end.longitude
  };
};
function getCubicBezierControlPoint(startCoordinate, endCoordinate) {
  const start = new google.maps.LatLng(startCoordinate.latitude, startCoordinate.longitude);
  const end = new google.maps.LatLng(endCoordinate.latitude, endCoordinate.longitude);
  const startEndDistance = google.maps.geometry.spherical.computeDistanceBetween(start, end);
  const distanceToCurvePoint = getDistanceToCurvePoint(startEndDistance);
  const curvatureCoefficent = getCurvatureCoefficient(distanceToCurvePoint);
  const initialHeadingFromStart = google.maps.geometry.spherical.computeHeading(start, end);
  const midPointCoordinate = google.maps.geometry.spherical.computeOffset(start, distanceToCurvePoint, initialHeadingFromStart);
  const angleStartEndVectorToCurvePointVector = 90;
  const controlPointLatLng = google.maps.geometry.spherical.computeOffset(midPointCoordinate, curvatureCoefficent, initialHeadingFromStart + angleStartEndVectorToCurvePointVector);
  const controlPointCoordinate = {
    longitude: controlPointLatLng.lng(),
    latitude: controlPointLatLng.lat()
  };
  return controlPointCoordinate;
}
function getDistanceToCurvePoint(startEndDistance) {
  const CURVATURE_DISTANCE_BREAKPOINT = 5000000;
  return startEndDistance > CURVATURE_DISTANCE_BREAKPOINT ? startEndDistance / 1.5 : startEndDistance / 2;
}
function getCurvatureCoefficient(distanceToCurvePoint) {
  const CURVATURE_ANGLE = Math.PI / 1.6;
  return distanceToCurvePoint * Math.cos(CURVATURE_ANGLE);
}

class DirectionsInstance {
  static getInstance() {
    if (!DirectionsInstance.Instance) {
      DirectionsInstance.Instance = new google.maps.DirectionsService();
    }
    return DirectionsInstance.Instance;
  }
}
DirectionsInstance.Instance = void 0;

function addAdvancedMarkerEventListeners(advancedMarker, markerListeners, marker) {
  // NOTE It is needed to set a listener to make the element interactive for the next EventListeners
  advancedMarker.addListener('click', () => {
    /**/
  });
  const listeners = [];
  for (const listener in markerListeners) {
    var _advancedMarker$conte;
    const callback = () => {
      var _markerListeners$list;
      return (_markerListeners$list = markerListeners[listener]) == null ? void 0 : _markerListeners$list.call(markerListeners, marker);
    };
    listeners.push({
      type: listener,
      callback: callback
    });
    (_advancedMarker$conte = advancedMarker.content) == null ? void 0 : _advancedMarker$conte.addEventListener(listener, callback);
  }
  return listeners;
}
function createGoogleMarkerClusterOptions(map, marker, clusterMarkerFactory, clusterOptions) {
  const renderer = {
    render: cluster => {
      return clusterMarkerFactory(marker, cluster, cluster.position);
    }
  };
  const algorithmOptions = {
    radius: clusterOptions == null ? void 0 : clusterOptions.radius,
    minPoints: clusterOptions == null ? void 0 : clusterOptions.minPoints
  };
  const algorithm = new SuperClusterAlgorithm(algorithmOptions);
  return {
    map,
    algorithm,
    renderer
  };
}

const routeCache = RouteCache.getInstance();
class MountedGoogleMap {
  get viewChanged() {
    return combineLatest([this.boundsChanged, this.idle]).pipe(distinctUntilChanged((prev, curr) => prev[1] === curr[1]), map(() => ({
      rectangle: this.getBoundingRectangle(),
      zoom: this.googleMap.getZoom()
    })));
  }
  constructor(googleMap, singleMarkerFactory, clusterMarkerFactory) {
    this.googleMap = void 0;
    this.singleMarkerFactory = void 0;
    this.clusterMarkerFactory = void 0;
    this.boundsChanged = new Subject();
    this.idle = new Subject();
    this.click = new Subject();
    this.allRenderers = [];
    this.directionsService = DirectionsInstance.getInstance();
    this.googleTravelModesByConnection = {
      [ConnectionType.NONE]: google.maps.TravelMode.WALKING,
      [ConnectionType.CAR]: google.maps.TravelMode.DRIVING,
      [ConnectionType.WALK]: google.maps.TravelMode.WALKING,
      [ConnectionType.BICYCLE]: google.maps.TravelMode.BICYCLING,
      //TODO: Change ConnectionType.FLIGHT withouth using google.maps.TravelMode
      [ConnectionType.FLIGHT]: google.maps.TravelMode.DRIVING,
      [ConnectionType.FERRY]: google.maps.TravelMode.DRIVING
    };
    this.existingPolylines = [];
    this.singleMapMarkers = new Set();
    this.markerClusterer = void 0;
    this.googleMap = googleMap;
    this.singleMarkerFactory = singleMarkerFactory;
    this.clusterMarkerFactory = clusterMarkerFactory;
    googleMap.addListener('bounds_changed', () => this.boundsChanged.next(new Date()));
    googleMap.addListener('idle', () => this.idle.next(new Date()));
    googleMap.addListener('click', () => this.click.next(new Date()));
  }
  clearRoutes() {
    this.allRenderers.forEach(renderer => {
      renderer.setDirections({
        geocoded_waypoints: [],
        routes: [],
        request: {
          destination: '',
          origin: '',
          travelMode: google.maps.TravelMode.DRIVING
        }
      });
    });
    this.allRenderers = [];
    this.existingPolylines.forEach(polyline => polyline.setMap(null));
  }
  addRoute(from, to, waypoints) {
    return new Promise(resolve => {
      const directionsRenderer = this.initializeDirectionsRenderer();
      const request = this.getDirectionsRequest(from, to, waypoints);
      const segmentResult = routeCache.getRouteFromCache({
        from,
        to,
        waypoints
      });
      const allPoints = [from, ...waypoints, to];
      if (segmentResult && this.allRenderers.indexOf(directionsRenderer) != -1) {
        directionsRenderer.setDirections(segmentResult);
        return resolve(this.getRoutesFromDirectionsResult(allPoints, segmentResult));
      } else {
        this.directionsService.route(request, (result, status) => {
          if (status === 'OK' && result && this.allRenderers.indexOf(directionsRenderer) != -1) {
            routeCache.addRouteInCache({
              from,
              to,
              waypoints
            }, result);
            directionsRenderer.setDirections(result);
            const response = this.getRoutesFromDirectionsResult(allPoints, result);
            resolve(response);
          }
        });
      }
    });
  }
  initializeDirectionsRenderer() {
    const rendererOptions = {
      markerOptions: {
        visible: false
      },
      preserveViewport: true,
      map: this.googleMap
    };
    const directionsRenderer = new google.maps.DirectionsRenderer(rendererOptions);
    this.allRenderers.push(directionsRenderer);
    return directionsRenderer;
  }
  getDirectionsRequest(from, to, waypoints) {
    const origin = new google.maps.LatLng(from.position.latitude, from.position.longitude);
    const destination = new google.maps.LatLng(to.position.latitude, to.position.longitude);
    const googleWaypoints = waypoints.map(waypoint => ({
      location: new google.maps.LatLng(waypoint.position.latitude, waypoint.position.longitude),
      stopover: true
    }));
    const connection = getConnectionType(to);
    return {
      origin,
      destination,
      waypoints: googleWaypoints,
      travelMode: this.googleTravelModesByConnection[connection]
    };
  }
  getRoutesFromDirectionsResult(markers, result) {
    const route = result.routes[0];
    return route.legs.map((leg, index) => {
      var _leg$distance, _leg$duration;
      const distanceInMeters = (_leg$distance = leg.distance) == null ? void 0 : _leg$distance.value;
      const timeInSeconds = (_leg$duration = leg.duration) == null ? void 0 : _leg$duration.value;
      const distanceInKilometers = distanceInMeters ? distanceInMeters / 1000 : undefined;
      const expectedTravelTimeInMinutes = timeInSeconds ? timeInSeconds / 60 : undefined;
      const fromMarker = markers[index];
      const toMarker = markers[index + 1];
      const connection = getConnectionType(last$1(markers));
      return {
        distanceInKilometers,
        expectedTravelTimeInMinutes,
        type: connection,
        from: Object.assign({}, fromMarker),
        to: Object.assign({}, toMarker)
      };
    });
  }
  addLine(startCoordinate, endCoordinate) {
    const controlPointCoordinate = getCubicBezierControlPoint(startCoordinate, endCoordinate);
    const POLYLINE_SEGMENT_SIZE = 0.05;
    this.drawCurvedPolylineOnMap(startCoordinate, controlPointCoordinate, endCoordinate, POLYLINE_SEGMENT_SIZE, this.googleMap);
  }
  drawCurvedPolylineOnMap(startCoordinate, controlPointCoordinate, endCoordinate, segmentStepSize, map) {
    const points = [];
    points.push(endCoordinate);
    for (let currentSegmentPoint = 0; currentSegmentPoint <= 1; currentSegmentPoint += segmentStepSize) {
      points.push(getPointPositionOnQuadraticBezierCurve(startCoordinate, controlPointCoordinate, endCoordinate, currentSegmentPoint));
    }
    const path = [];
    path.push(new google.maps.LatLng(startCoordinate.latitude, startCoordinate.longitude, false));
    for (let i = 0; i < points.length - 1; i++) {
      path.push(new google.maps.LatLng(points[i + 1].latitude, points[i + 1].longitude, false));
    }
    path.push(new google.maps.LatLng(endCoordinate.latitude, endCoordinate.longitude, false));
    const polyline = new google.maps.Polyline({
      path,
      geodesic: false,
      strokeOpacity: 1.0,
      strokeColor: 'black',
      strokeWeight: 2
    });
    polyline.setMap(map);
    this.existingPolylines.push(polyline);
  }
  replaceMarker(existingMarker, newMarker, newMarkerListeners, newClusterOptions) {
    this.removeMarker(existingMarker);
    const newAddedMarker = this.addMarker(newMarker, newMarkerListeners, newClusterOptions);
    return newAddedMarker;
  }
  addMarker(marker, markerListeners, clusterOptions) {
    const position = new google.maps.LatLng(marker.position.latitude, marker.position.longitude);
    const singleMarker = this.singleMarkerFactory(marker, position);
    const addedGoogleMapsMarker = {
      marker: singleMarker,
      position,
      listeners: addAdvancedMarkerEventListeners(singleMarker, markerListeners, marker),
      isClustered: !!marker.cluster
    };
    if (marker.cluster) {
      if (!this.markerClusterer) {
        const markerClustererOptions = createGoogleMarkerClusterOptions(this.googleMap, marker, this.clusterMarkerFactory, clusterOptions);
        this.markerClusterer = new MarkerClusterer(markerClustererOptions);
      }
      this.markerClusterer.addMarker(singleMarker);
    } else {
      addedGoogleMapsMarker.marker.map = this.googleMap;
    }
    this.singleMapMarkers.add(addedGoogleMapsMarker);
    return addedGoogleMapsMarker;
  }
  removeMarker(marker) {
    if (marker.isClustered) {
      if (!this.markerClusterer) {
        throw new Error('Trying to remove a marker without setting properly markerClusterer');
      }
      this.markerClusterer.removeMarker(marker.marker);
    } else {
      marker.marker.map = null;
    }
    marker.listeners.forEach(listener => removeEventListener(listener.type, listener.callback));
    this.singleMapMarkers.delete(marker);
    if (this.singleMapMarkers.size === 0) {
      this.markerClusterer = undefined;
    }
  }
  removeAllMarkers() {
    this.singleMapMarkers.forEach(marker => this.removeMarker(marker));
  }
  async showMarkers(markers) {
    if (markers.length === 0) {
      return Promise.resolve();
    }
    const bounds = markers.reduce((current, x) => current.extend(x.position), new google.maps.LatLngBounds());
    const minArea = 0.001;
    const neBoundCoordinates = bounds.getNorthEast().toJSON();
    const swBoundCoordinates = bounds.getSouthWest().toJSON();
    const area = (Math.pow(neBoundCoordinates.lng - swBoundCoordinates.lng, 2) + Math.pow(neBoundCoordinates.lat - swBoundCoordinates.lat, 2)) / 2;
    if (area === 0) {
      const extra = 0.04;
      const neCoordinate = new google.maps.LatLng(neBoundCoordinates.lat + extra, neBoundCoordinates.lng + extra);
      const swCoordinate = new google.maps.LatLng(swBoundCoordinates.lat - extra, swBoundCoordinates.lng - extra);
      bounds.extend(neCoordinate).extend(swCoordinate);
    } else if (area < minArea && area > 0) {
      const x = neBoundCoordinates.lng - swBoundCoordinates.lng;
      const y = neBoundCoordinates.lat - swBoundCoordinates.lat;
      const r = x / y;
      const b = Math.sqrt(minArea / r);
      const a = r * b;
      const H = (a - x) / 2;
      const V = (b - y) / 2;
      const newNE = Object.assign({}, neBoundCoordinates);
      newNE.lat += V;
      newNE.lng += H;
      const newSW = Object.assign({}, swBoundCoordinates);
      newSW.lat -= V;
      newSW.lng -= H;
      const neCoordinate = new google.maps.LatLng(newNE.lat, newNE.lng);
      const swCoordinate = new google.maps.LatLng(newSW.lat, newSW.lng);
      bounds.extend(neCoordinate).extend(swCoordinate);
    }
    this.googleMap.fitBounds(bounds);
    await lastValueFrom(this.idle.pipe(take(1)));
  }
  async center(rectangle) {
    this.googleMap.fitBounds(this.rectangleToLatLngBounds(rectangle));
    await lastValueFrom(this.idle.pipe(take(1)));
  }
  rectangleToLatLngBounds(rectangle) {
    return new google.maps.LatLngBounds(new google.maps.LatLng(rectangle.bottomRight.latitude, rectangle.topLeft.longitude), new google.maps.LatLng(rectangle.topLeft.latitude, rectangle.bottomRight.longitude));
  }
  getBoundingRectangle() {
    const bounds = this.googleMap.getBounds();
    if (!bounds) {
      console.warn('No bounds');
      return {
        topLeft: {
          latitude: 0,
          longitude: 0
        },
        bottomRight: {
          latitude: 0,
          longitude: 0
        }
      };
    }
    return this.latLngBoundsToRectangle(bounds);
  }
  latLngBoundsToRectangle(bounds) {
    const ne = bounds.getNorthEast();
    const sw = bounds.getSouthWest();
    return {
      topLeft: {
        latitude: ne.lat(),
        longitude: sw.lng()
      },
      bottomRight: {
        latitude: sw.lat(),
        longitude: ne.lng()
      }
    };
  }
  destroy() {
    this.clearRoutes();
    this.removeAllMarkers();
    if (!googleMapElement) {
      throw new Error("Don't find google Map Element to hide");
    }
    putMapInBody(googleMapElement);
  }
}

let loaderStatus = 'idle';
const loaderStatusSubject = new ReplaySubject();
loaderStatusSubject.subscribe(status => loaderStatus = status);
let googleMapInstance;
let googleMapElement;
class GoogleMapsIntegration {
  async loadMapsLibrary(options) {
    var _options$locale;
    loaderStatusSubject.next('loading');
    const loader = new GoogleMapsLoader(GOOGLE_API_KEY, {
      language: (_options$locale = options == null ? void 0 : options.locale) != null ? _options$locale : 'en'
    });
    await Promise.all([loader.loadMapsApi, loader.loadLibrary('marker'), loader.loadLibrary('geometry')]);
    loaderStatusSubject.next('loaded');
  }
  async createDynamicMapIntegration(element, options) {
    if (loaderStatus === 'idle') {
      await this.loadMapsLibrary(options);
    }
    await firstValueFrom(loaderStatusSubject.pipe(first(status => status === 'loaded')));
    googleMapElement = getSingleMapContainer();
    if (!googleMapInstance || !googleMapElement) {
      googleMapElement = setSingleMapContainer();
      googleMapInstance = setGoogleMapInstance(googleMapElement, options);
    } else {
      updateMapInstanceOptions(googleMapInstance, options);
    }
    putMapInContainer(element, googleMapElement);
    const singleMarkerFactory = (marker, position) => {
      let markerFormatter;
      if (marker.useContentFormatter && options != null && options.markerFormatters && options.markerFormatters[marker.useContentFormatter]) {
        markerFormatter = options.markerFormatters[marker.useContentFormatter];
      } else {
        markerFormatter = defaultMarkerFormatter;
      }
      const content = markerFormatter(marker, {
        integration: 'google'
      });
      const displayPriority = marker.displayPriority ? marker.displayPriority + 1 : 1;
      const singleMarker = new google.maps.marker.AdvancedMarkerElement({
        position,
        content
      });
      singleMarker.element.classList.add('google-marker-container');
      singleMarker.element.style.zIndex = displayPriority.toString();
      return singleMarker;
    };
    const clusterMarkerFactory = (marker, cluster, position) => {
      let markerFormatter;
      if (marker.useClusterContentFormatter && options != null && options.clusterMarkerFormatters && options.clusterMarkerFormatters[marker.useClusterContentFormatter]) {
        markerFormatter = options.clusterMarkerFormatters[marker.useClusterContentFormatter];
      } else {
        markerFormatter = defaultClusterMarkerFormatter;
      }
      const content = markerFormatter(marker, cluster, {
        integration: 'google'
      });
      const displayPriority = 0;
      const clusterMarker = new google.maps.marker.AdvancedMarkerElement({
        position,
        content
      });
      clusterMarker.element.classList.add('google-marker-container');
      clusterMarker.element.style.zIndex = displayPriority.toString();
      return clusterMarker;
    };
    const mountedMap = new MountedGoogleMap(googleMapInstance, singleMarkerFactory, clusterMarkerFactory);
    return mountedMap;
  }
}

class MountedGoogleStaticMap {
  constructor(element, url) {
    this.element = void 0;
    this.url = void 0;
    this.mapElement = document.createElement('img');
    this.element = element;
    this.url = url;
    this.mapElement.src = this.url;
    this.mapElement.alt = 'static map';
    this.element.appendChild(this.mapElement);
  }
  destroy() {
    this.element.removeChild(this.mapElement);
  }
}

function getPathFromMarkers(markers) {
  return markers.reduce((acc, marker) => {
    const latitude = `${marker.position.latitude}`;
    const longitude = `${marker.position.longitude}`;
    acc += `|${latitude},${longitude}`;
    return acc;
  }, '');
}

const mapStyles = [{
  featureType: 'landscape.natural',
  stylers: [{
    color: '#d0ece0'
  }, {
    visibility: 'on'
  }]
}, {
  featureType: 'poi.attraction',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'poi.business',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'poi.school',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'road.highway',
  stylers: [{
    visibility: 'simplified'
  }]
}];
function mapStyleToURLStyleParameter(style) {
  const styleURLParameter = [];
  style.forEach(feature => {
    let styleFeature = `feature:${feature.featureType}`;
    let featureStyler = '';
    feature.stylers.forEach(styler => {
      const styleStyler = `|${Object.keys(styler)}:${Object.values(styler)}`;
      featureStyler = featureStyler.concat(styleStyler);
    });
    styleFeature = styleFeature.concat('', featureStyler);
    styleURLParameter.push(styleFeature);
  });
  return styleURLParameter;
}

const DEFAULT_PATH_FORMAT = 'color:0x302a47ff|weight:2';
class GoogleStaticMapIntegration {
  constructor() {
    this.staticMapBaseUrl = 'https://maps.googleapis.com/maps/api/staticmap';
    this.maxZoom = 13;
  }
  async createMap(element, options) {
    const staticMapURL = this.createUrl(GOOGLE_STATIC_API_KEY, options);
    return new MountedGoogleStaticMap(element, staticMapURL);
  }
  createUrl(apiKey, options) {
    const parameters = this.getQueryParameters(apiKey, options);
    return `${this.staticMapBaseUrl}?${parameters}`;
  }
  getQueryParameters(apiKey, options) {
    var _options$markers;
    const query = {
      key: [apiKey]
    };
    query.size = [`${options.size.width}x${options.size.height}`];
    if (options.markers) {
      query.markers = options.markers.map(marker => {
        const markerFormatter = marker.useContentFormatter && options != null && options.markerFormatters ? `icon:${options.markerFormatters[marker.useContentFormatter]}|` : '';
        return `${markerFormatter}${marker.position.latitude},${marker.position.longitude}`;
      });
    }
    if (options.markers && options.autogeneratePaths) {
      const path = getPathFromMarkers(options.markers);
      const pathFormat = options.pathFormat || DEFAULT_PATH_FORMAT;
      query.path = [`${pathFormat}${path}`];
    }
    if (((_options$markers = options.markers) == null ? void 0 : _options$markers.length) === 1) {
      query.zoom = [`${this.maxZoom}`];
    }
    if (options.center) {
      var _options$zoomLevel$to, _options$zoomLevel;
      query.zoom = [(_options$zoomLevel$to = (_options$zoomLevel = options.zoomLevel) == null ? void 0 : _options$zoomLevel.toString()) != null ? _options$zoomLevel$to : `${this.maxZoom}`];
      if (Array.isArray(options.center)) {
        query.visible = [options.center.map(coordinate => {
          return `${coordinate.latitude},${coordinate.longitude}`;
        }).join('|')];
      } else {
        const center = options.center;
        query.center = [`${center.latitude},${center.longitude}`];
      }
    }
    if (options.scale) {
      query.scale = [options.scale.toString()];
    }
    query['style'] = mapStyleToURLStyleParameter(mapStyles);
    return renderQuery(query);
  }
}

var GoogleAddressComponentTypes;
(function (GoogleAddressComponentTypes) {
  GoogleAddressComponentTypes["None"] = "none";
  GoogleAddressComponentTypes["Route"] = "route";
  GoogleAddressComponentTypes["StreetNumber"] = "street_number";
  GoogleAddressComponentTypes["Locality"] = "locality";
  GoogleAddressComponentTypes["SubLocality"] = "sublocality";
  GoogleAddressComponentTypes["SubLocalityLevel"] = "sublocality_level_1";
  GoogleAddressComponentTypes["PostalTown"] = "postal_town";
  GoogleAddressComponentTypes["Country"] = "country";
  GoogleAddressComponentTypes["PostalCode"] = "postal_code";
})(GoogleAddressComponentTypes || (GoogleAddressComponentTypes = {}));

function getGeocodeRequest(criteria) {
  const geocodeRequest = {};
  if (criteria.position) {
    geocodeRequest.location = new google.maps.LatLng(criteria.position.latitude, criteria.position.longitude);
  }
  if (criteria.place) {
    geocodeRequest.placeId = criteria.place;
  }
  if (criteria.language) {
    geocodeRequest.language = criteria.language;
  }
  return geocodeRequest;
}
function getComponentLongName(fromComponents, ofTypes) {
  const componentOfSpecifiedTypes = fromComponents.find(component => intersectionIsNotEmpty(component.types, ofTypes));
  return componentOfSpecifiedTypes == null ? void 0 : componentOfSpecifiedTypes.long_name;
}
function intersectionIsNotEmpty(t1, t2) {
  return !!intersection(t1, t2).length;
}

class GeocodingService {
  constructor(language = 'en') {
    this.loadedService = void 0;
    this.loadedService = new Promise((resolve, reject) => {
      const loader = new GoogleMapsLoader(GOOGLE_API_KEY, {
        language
      });
      loader.loadLibrary('geocoding').then(({
        Geocoder
      }) => resolve(new Geocoder())).catch(error => reject(error));
    });
  }
  async getLocation(criteria) {
    const geocodeRequest = getGeocodeRequest(criteria);
    const service = await this.loadedService;
    return new Promise((resolve, reject) => {
      service.geocode(geocodeRequest, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK && results) {
          const firstLocation = results[0];
          const addressComponents = firstLocation.address_components;
          const route = getComponentLongName(addressComponents, [GoogleAddressComponentTypes.Route]);
          const streetNumber = getComponentLongName(addressComponents, [GoogleAddressComponentTypes.StreetNumber]);
          const locality = getComponentLongName(addressComponents, [GoogleAddressComponentTypes.Locality]);
          const subLocality = getComponentLongName(addressComponents, [GoogleAddressComponentTypes.SubLocality, GoogleAddressComponentTypes.SubLocalityLevel]);
          const postalTown = getComponentLongName(addressComponents, [GoogleAddressComponentTypes.PostalTown]);
          const country = getComponentLongName(addressComponents, [GoogleAddressComponentTypes.Country]);
          const postalCode = getComponentLongName(addressComponents, [GoogleAddressComponentTypes.PostalCode]);
          resolve({
            formattedAddress: firstLocation.formatted_address,
            route,
            country,
            streetNumber,
            locality,
            subLocality,
            postalTown,
            postalCode,
            position: {
              latitude: firstLocation.geometry.location.lat(),
              longitude: firstLocation.geometry.location.lng()
            }
          });
        } else {
          reject(new Error(`Geocode was not successful for the following reason: ${status}`));
        }
      });
    });
  }
}

var $ = _export;
var DESCRIPTORS = descriptors;
var global$1 = global$k;
var uncurryThis = functionUncurryThis;
var hasOwn = hasOwnProperty_1;
var isCallable = isCallable$l;
var isPrototypeOf = objectIsPrototypeOf;
var toString = toString$2;
var defineProperty = objectDefineProperty.f;
var copyConstructorProperties = copyConstructorProperties$2;

var NativeSymbol = global$1.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineProperty(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

function mapPrediction(fromGooglePrediction) {
  return {
    id: fromGooglePrediction.place_id,
    description: fromGooglePrediction.description
  };
}

class AutoCompleteService {
  constructor(language = 'en') {
    this.loadedService = void 0;
    this.loadedService = new Promise((resolve, reject) => {
      const loader = new GoogleMapsLoader(GOOGLE_API_KEY, {
        language
      });
      loader.loadLibrary('places').then(({
        AutocompleteService
      }) => resolve(new AutocompleteService())).catch(error => reject(error));
    });
  }
  async getAutocompleteSuggestions(input) {
    const request = {
      input
    };
    const service = await this.loadedService;
    return new Promise((resolve, reject) => {
      service.getPlacePredictions(request, (results, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && results) {
          const mappedResults = results.map(mapPrediction);
          resolve(mappedResults);
        } else {
          reject(new Error(`GetPlacePredictions was not successful for the following reason: ${status}`));
        }
      });
    });
  }
}

let initialized = false;
const DEFAULT_VERSION = '5.x.x';
const MAX_ZOOM_OUT_METERS = 9000000;
const MIN_ZOOM_OUT_METERS = 0;
const authCallback = done => {
  done('eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IkRNU0IyNDM2MlAifQ.eyJpc3MiOiJCNkJSTFNKNTJYIiwiaWF0IjoxNjMxMTc5ODE2LCJleHAiOjE2NjI2ODE2MDB9.rFC56it75nWytVn5fLTGdBWQlM7MlTGLGxDaRCF11V_-tawQ6fEqgtTJE85YesPfScf2pJ88-zyoIANBmaClnA');
};
function loadMapkit(version = DEFAULT_VERSION) {
  return new Promise((resolve, reject) => {
    const src = `https://cdn.apple-mapkit.com/mk/${version}/mapkit.js`;
    if (window.mapkit) {
      return resolve();
    }
    const script = document.createElement('script');
    script.onload = () => resolve();
    script.onerror = error => reject(error);
    document.body.appendChild(script);
    script.src = src;
  });
}
async function createMapkit(container, options) {
  await loadMapkit();
  if (!initialized) {
    window.mapkit.init(options);
    initialized = true;
  }
  return new window.mapkit.Map(container);
}
class MountedMapkitMap {
  constructor(map, markerFormatters) {
    this.map = void 0;
    this.markerFormatters = void 0;
    this.mapKitTransportsByConnection = {
      [ConnectionType.NONE]: mapkit.Directions.Transport.Automobile,
      [ConnectionType.CAR]: mapkit.Directions.Transport.Automobile,
      [ConnectionType.WALK]: mapkit.Directions.Transport.Walking,
      [ConnectionType.BICYCLE]: mapkit.Directions.Transport.Walking
    };
    this.map = map;
    this.markerFormatters = markerFormatters;
  }
  get viewChanged() {
    return this.fromMapEvent(this.map, 'region-change-end').pipe(map(() => ({
      rectangle: this.getBoundingRectangle()
    })));
  }
  fromMapEvent(map, type) {
    return new Observable(subscribe => {
      const listener = event => subscribe.next(event);
      map.addEventListener(type, listener);
      return () => map.removeEventListener(type, listener);
    });
  }
  replaceMarker(existingMarker, newMarker, newMarkerListeners) {
    this.removeMarker(existingMarker);
    const newAddedMarker = this.addMarker(newMarker, newMarkerListeners);
    return newAddedMarker;
  }
  addMarker(marker, listeners) {
    const mapMarker = this.createMapMarkerAnnotation(marker, listeners, this.markerFormatters);
    return {
      marker: this.map.addAnnotation(mapMarker),
      listeners
    };
  }
  createMapMarkerAnnotation(marker, listeners, markerFormatters) {
    const coordinate = new mapkit.Coordinate(marker.position.latitude, marker.position.longitude);
    const isGlyphMarker = marker.cssClass === undefined;
    return isGlyphMarker ? this.createGlyphMarker(coordinate, marker, listeners) : this.createCustomMarker(coordinate, marker, listeners, markerFormatters);
  }
  createGlyphMarker(coordinate, marker, listeners) {
    const markerAnnotation = new mapkit.MarkerAnnotation(coordinate);
    markerAnnotation.title = marker.title || '';
    markerAnnotation.subtitle = marker.subtitle || '';
    markerAnnotation.animates = false;
    markerAnnotation.data = marker;
    for (const listener in listeners) {
      markerAnnotation.element.addEventListener(listener, () => {
        var _listeners$listener;
        return (_listeners$listener = listeners[listener]) == null ? void 0 : _listeners$listener.call(listeners, marker);
      });
    }
    return markerAnnotation;
  }
  createCustomMarker(coordinate, marker, listeners, markerFormatters) {
    var _marker$displayPriori;
    let markerFormatter = defaultMarkerFormatter;
    if (marker.useContentFormatter && markerFormatters) {
      markerFormatter = markerFormatters[marker.useContentFormatter] || defaultMarkerFormatter;
    }
    const annotationWithInfoBox = new mapkit.Annotation(coordinate, (x, y) => (markerFormatter || defaultMarkerFormatter)(y.data, {
      integration: 'apple'
    }), {
      title: marker.title,
      anchorOffset: new DOMPoint(-8, -1),
      data: marker,
      displayPriority: (_marker$displayPriori = marker.displayPriority) != null ? _marker$displayPriori : 0
    });
    for (const listener in listeners) {
      annotationWithInfoBox.element.addEventListener(listener, () => {
        var _listeners$listener2;
        return (_listeners$listener2 = listeners[listener]) == null ? void 0 : _listeners$listener2.call(listeners, marker);
      });
    }
    annotationWithInfoBox.calloutEnabled = false;
    return annotationWithInfoBox;
  }
  removeMarker(marker) {
    for (const listener in marker.listeners) {
      marker.marker.element.removeEventListener(listener, () => marker.listeners[listener]);
    }
    this.map.removeAnnotation(marker.marker);
  }
  showMarkers(markers) {
    this.map.showItems(markers.map(x => x.marker));
    return Promise.resolve();
  }
  center(rectangle) {
    this.setAreaForMap(this.map, rectangle);
    return Promise.resolve();
  }
  setAreaForMap(map, rectangle) {
    const region = new mapkit.BoundingRegion(rectangle.topLeft.latitude, rectangle.bottomRight.longitude, rectangle.bottomRight.latitude, rectangle.topLeft.longitude);
    log('Set region', rectangle, region);
    map.setRegionAnimated(region.toCoordinateRegion(), false);
  }
  getBoundingRectangle() {
    const currentViewRectangle = this.map.visibleMapRect;
    const coordinateRegion = currentViewRectangle.toCoordinateRegion();
    const boundingRegion = coordinateRegion.toBoundingRegion();
    const topLeft = {
      latitude: boundingRegion.northLatitude > 90 ? 90 : boundingRegion.northLatitude,
      longitude: boundingRegion.westLongitude
    };
    const bottomRight = {
      latitude: boundingRegion.southLatitude < -90 ? -90 : boundingRegion.southLatitude,
      longitude: boundingRegion.eastLongitude
    };
    return {
      bottomRight,
      topLeft
    };
  }
  setMarkers(markers, showAllMarkers, listeners) {
    const newMarkers = markers.map(x => this.createMapMarkerAnnotation(x, listeners));
    this.map.removeAnnotations(this.map.annotations);
    this.map.addAnnotations(newMarkers);
    if (showAllMarkers) {
      this.map.showItems(this.map.annotations);
    }
  }
  destroy() {
    this.map.destroy();
  }
  clearRoutes() {
    this.map.overlays = [];
  }
  async addRoute(from, to) {
    const calculatedRoute = [];
    const directions = await this.getDirections(from, to, this.mapKitTransportsByConnection);
    const routes = this.getMapKitRoutes(directions, 1);
    if (routes.length === 0) {
      return [];
    }
    this.drawRoute(routes);
    calculatedRoute.push(this.convertToRoute(routes[0], from, to));
    return calculatedRoute;
  }
  getDirections(origin, destination, mapKitTransportsByConnection) {
    return new Promise((resolve, reject) => {
      const route = this.createRoute(origin, destination, mapKitTransportsByConnection);
      const directions = new mapkit.Directions();
      directions.route(route, (error, data) => {
        if (error) {
          reject(error);
        }
        resolve(data);
      });
    });
  }
  createRoute(from, to, mapKitTransportsByConnection) {
    const connection = getConnectionType(to);
    const transport = mapKitTransportsByConnection[connection];
    const origin = new mapkit.Coordinate(from.position.latitude, from.position.longitude);
    const destination = new mapkit.Coordinate(to.position.latitude, to.position.longitude);
    return {
      origin,
      destination,
      transportType: transport,
      requestsAlternateRoutes: false
    };
  }
  getMapKitRoutes(data, maxNumberOfRoutes) {
    const sortedByExpectedTravelTime = sortBy(data.routes, route => route.expectedTravelTime);
    return take$1(sortedByExpectedTravelTime, maxNumberOfRoutes);
  }
  convertToRoute(fromRoutes, origin, destination) {
    const expectedTravelTimeInSeconds = fromRoutes.expectedTravelTime;
    const distanceInMeters = fromRoutes.distance;
    const connection = getConnectionType(destination);
    return {
      expectedTravelTimeInMinutes: expectedTravelTimeInSeconds / 60,
      distanceInKilometers: distanceInMeters / 1000,
      from: origin,
      to: destination,
      type: connection
    };
  }
  addLine(from, to) {
    const originCoordinates = new mapkit.Coordinate(from.latitude, from.longitude);
    const destinationCoordinates = new mapkit.Coordinate(to.latitude, to.longitude);
    const coords = [originCoordinates, destinationCoordinates];
    const style = new mapkit.Style({
      lineWidth: 2,
      lineJoin: 'round',
      strokeColor: 'black'
    });
    const polyline = new mapkit.PolylineOverlay(coords, {
      style
    });
    this.map.addOverlay(polyline);
  }
  // public async geoEncode(query: string): Promise<CoordinatesWithAddress[]> {
  //     const result = await new Promise<mapkit.SearchAutocompleteResponse>(
  //         (resolve, reject) => {
  //             const autocomplete = new mapkit.Search();
  //             autocomplete.autocomplete(query, (error, data) => {
  //                 if (error) {
  //                     reject(error);
  //                 }
  //                 resolve(data);
  //             });
  //         }
  //     );
  //     return result.results.map((res) => {
  //         return {
  //             coordinate: res.coordinate,
  //             address: res.displayLines.join(','),
  //         };
  //     });
  // }
  drawRoute(routes) {
    routes.forEach(route => {
      const polyline = route.polyline;
      polyline.style = new mapkit.Style({
        lineWidth: 2
      });
      this.map.addOverlay(polyline);
    });
  }
}
class MapkitMapIntegration {
  async createDynamicMapIntegration(element, options) {
    var _options$locale;
    return new MountedMapkitMap(await this.initialize({
      ref: element,
      isRotationEnabled: !!(options != null && options.mapControls.includes(MapControl.rotateControl)),
      locale: (_options$locale = options == null ? void 0 : options.locale) != null ? _options$locale : 'en'
    }), options == null ? void 0 : options.markerFormatters);
  }
  async initialize(options) {
    const map = await createMapkit(options.ref, {
      authorizationCallback: authCallback,
      language: options.locale
    });
    const range = new mapkit.CameraZoomRange(MIN_ZOOM_OUT_METERS, MAX_ZOOM_OUT_METERS);
    map.cameraZoomRange = range;
    map.isRotationEnabled = options.isRotationEnabled;
    return map;
  }
}
function createCoordinate(latitude, longitude) {
  return new mapkit.Coordinate(latitude, longitude);
}

function createPolygonFromRectangle(rectangle) {
  return [rectangle.topLeft, {
    latitude: rectangle.topLeft.latitude,
    longitude: rectangle.bottomRight.longitude
  }, rectangle.bottomRight, {
    latitude: rectangle.bottomRight.latitude,
    longitude: rectangle.topLeft.longitude
  }, rectangle.topLeft];
}
function toGeoPolygon(polygon) {
  return {
    type: 'Polygon',
    coordinates: [polygon.map(x => [x.longitude, x.latitude])]
  };
}
function isRectangle(coordinates) {
  if (coordinates.length !== 5) {
    return false;
  }
  const topLeft = coordinates[0];
  const topRight = coordinates[1];
  const bottomRight = coordinates[2];
  const bottomLeft = coordinates[3];
  const closingTopLeft = coordinates[4];
  const shouldBeEqual = [[topLeft.latitude, closingTopLeft.latitude], [topLeft.longitude, closingTopLeft.longitude], [topLeft.latitude, topRight.latitude], [topLeft.longitude, bottomLeft.longitude], [topRight.longitude, bottomRight.longitude], [bottomLeft.latitude, bottomRight.latitude]];
  log('Coordinates', shouldBeEqual);
  return shouldBeEqual.every(x => x[0] === x[1]);
}
function tryCreateRectangle(coordinates) {
  if (!isRectangle(coordinates)) {
    return null;
  }
  return createRectangle(coordinates);
}
function createRectangle(coordinates) {
  return {
    topLeft: coordinates[0],
    bottomRight: coordinates[2]
  };
}

export { AutoCompleteService, ConnectionType, DirectionsService, GeocodingService, GoogleMapsIntegration, GoogleMapsLoader, GoogleStaticMapIntegration, Map$1 as Map, MapControl, MapIntegrationType, MapType, MapkitMapIntegration, MountedGoogleMap, MountedGoogleStaticMap, StaticMap, createCoordinate, createMap, createPolygonFromRectangle, createRectangle, createStaticMap, defaultClusterMarkerFormatter, defaultMarkerFormatter, getConnectionType, googleMapElement, isRectangle, toGeoPolygon, tryCreateRectangle };
